module.exports = __webpack_public_path__ + "img/full_logo_white.4061af80.png";